import styled from "styled-components";
import {useMemo} from "react";
import {ReactComponent as ImageIcon} from "../../../../Assets/icon/image.svg";
import {ReactComponent as VideoIcon} from "../../../../Assets/icon/video.svg";
import {ReactComponent as AudioIcon} from "../../../../Assets/icon/audio.svg";
import {ReactComponent as DocumentIcon} from "../../../../Assets/icon/document.svg";

function MediaLogo({ data }: { data: any }) {

    const icon = useMemo(() => {
        if (data.message.imageMessage || data.contentType === "image") {
            return <ImageIcon />;
        }

        if (data.message.videoMessage || data.contentType === "video") {
            return <VideoIcon />;
        }

        if (data.message.audioMessage || data.contentType === "audio") {
            return <AudioIcon />;
        }

        if (data.message.documentMessage || data.contentType === "document") {
            return <DocumentIcon />;
        }

        return null;
    }, [data]);

    if (!icon) return null;

    return (
        <Footer>
            <Icon fromMe={data.key.fromMe}>
                {icon}
            </Icon>
        </Footer>
    );
}

export default MediaLogo;

const Footer = styled.div`
    padding: 8px 8px 0;
    min-width: 64px;
`;

const Icon = styled.div`
    svg {
        fill: ${({fromMe}: { fromMe: boolean }) => fromMe ? "#fff" : "#0f7bff"};
        width: 16px;
        height: 16px;
    }
`;
